module.exports = __webpack_public_path__ + "static/media/performance-analysis.60f5ecbd.svg";